import { Box, Skeleton, Stack, useTheme } from "@mui/material";

const DiscoveryTopToolbarSkeletion = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: "4px",
        border: `1px solid ${theme.custom.borderGrey}`,
        background: "white",
        padding: "7px 12px",
        marginBottom: "12px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Stack direction={"row"} gap={1}>
        <Skeleton
          variant="rounded"
          height={45}
          width={350}
          sx={{ backgroundColor: "#EBEBEB" }}
        />
        <Skeleton
          variant="rounded"
          height={45}
          width={45}
          sx={{ backgroundColor: "#EBEBEB" }}
        />
      </Stack>
      <Stack direction={"row"} gap={1}>
        <Skeleton
          variant="rounded"
          height={40}
          width={110}
          sx={{ backgroundColor: "#EBEBEB" }}
        />
        <Skeleton
          variant="rounded"
          height={40}
          width={110}
          sx={{ backgroundColor: "#EBEBEB" }}
        />
        <Skeleton
          variant="rounded"
          height={40}
          width={110}
          sx={{ backgroundColor: "#EBEBEB" }}
        />
      </Stack>
      <Stack direction={"row"} gap={2}>
        <Skeleton
          variant="rounded"
          height={45}
          width={180}
          sx={{ backgroundColor: "#EBEBEB" }}
        />
        <Skeleton
          variant="rounded"
          height={45}
          width={100}
          sx={{ backgroundColor: "#EBEBEB" }}
        />
      </Stack>
    </Box>
  );
};

export default DiscoveryTopToolbarSkeletion;
